/*
  This file contains the logic for the cabinet form, mainly for multi-bay cabinets.
  The logic is used to adjust the width of the sections of the cabinet based on the width of the cabinet.
 */
  import { convertMmToInchesAndFormat } from "./mm-inches.js";
  import { updateInchValue } from "./mm-inches.js";
// Horizontal multi-bay cabinet form logic
(function () {

  let cabinet_bay_qty = jQuery("#_cabinet_bay_qty").val();
  let bay_orientation = jQuery("#_cabinet_bay_orientation").val();
  
  if (bay_orientation != "Horizontal") return;

  if ( cabinet_bay_qty < 2 ) return;

  let width = jQuery("#width_input");
  let select_adjustable_width = jQuery("#select_adjustable_width_input");
  let left_section_width = jQuery("#left_section_width_input");
  let middle_section_width = jQuery("#middle_section_width_input");
  let right_section_width = jQuery("#right_section_width_input");
  let left_section_width_label = jQuery("#input_label_left_section_width");
  let middle_section_width_label = jQuery("#input_label_middle_section_width");
  let right_section_width_label = jQuery("#input_label_right_section_width");

  width.change(function () {
    updateSectionWidth("left", ["right", "middle"]);
    updateSectionWidth("middle", ["left", "right"]);
    updateSectionWidth("right", ["left", "middle"]);
    updateHorizontalSectionMinMax();
  });

  left_section_width.change(function () {
    updateSectionWidth("middle", ["left", "right"]);
    updateSectionWidth("right", ["left", "middle"]);
  });

  middle_section_width.change(function () {
    updateSectionWidth("left", ["right", "middle"]);
    updateSectionWidth("right", ["left", "middle"]);
  });

  right_section_width.change(function () {
    updateSectionWidth("left", ["right", "middle"]);
    updateSectionWidth("middle", ["left", "right"]);
  });

  // toggle the disabled attribute of the width fields based on the selected option
  select_adjustable_width.change(function () {

    switch (select_adjustable_width.val()) {
      case "Left":
        left_section_width.prop("disabled", false);
        right_section_width.prop("disabled", true);
        middle_section_width.prop("disabled", true);
        break;
      case "Right":
        right_section_width.prop("disabled", false);
        left_section_width.prop("disabled", true);
        middle_section_width.prop("disabled", true);
        break;
      case "Middle":
        middle_section_width.prop("disabled", false);
        left_section_width.prop("disabled", true);
        right_section_width.prop("disabled", true);
        break;
      case "Left and Right":
        left_section_width.prop("disabled", false);
        right_section_width.prop("disabled", false);
        middle_section_width.prop("disabled", true);
        break;
      case "Left and Middle":
        left_section_width.prop("disabled", false);
        middle_section_width.prop("disabled", false);
        right_section_width.prop("disabled", true);
        break;
      case "Middle and Right":
        middle_section_width.prop("disabled", false);
        right_section_width.prop("disabled", false);
        left_section_width.prop("disabled", true);
        break;
      case "All Equal Sizes":
        left_section_width.prop("disabled", true);
        right_section_width.prop("disabled", true);
        middle_section_width.prop("disabled", true);
        break;
    }
    updateSectionWidth("left", ["right", "middle"]);
    updateSectionWidth("middle", ["left", "right"]);
    updateSectionWidth("right", ["left", "middle"]);
  });

  function updateSectionWidth(sectionToUpdate, sectionsToSubtract) {
    let newVal;

    let select_adjustable_width_val = select_adjustable_width
      .val()
      .toLowerCase();

    if (cabinet_bay_qty == 2) {
      switch (select_adjustable_width_val) {
        case "all equal sizes":
          newVal = width.val() / 2;
          break;
        case sectionsToSubtract[0]:
          newVal =
            width.val() -
            jQuery(`#${sectionsToSubtract[0]}_section_width_input`).val();
          break;
      }
    }
    if (cabinet_bay_qty == 3) {

      switch (select_adjustable_width_val) {
        case "all equal sizes":
          newVal = width.val() / 3;
          break;
        case sectionsToSubtract[0]:
          newVal =
            (width.val() -
              jQuery(`#${sectionsToSubtract[0]}_section_width_input`).val()) /
            2;
          break;
          case sectionsToSubtract[1]:
          newVal =
            (width.val() -
              jQuery(`#${sectionsToSubtract[1]}_section_width_input`).val()) /
            2;
          break;
        case sectionsToSubtract[0] + " and " + sectionsToSubtract[1]:
          newVal =
            width.val() -
            jQuery(`#${sectionsToSubtract[0]}_section_width_input`).val() -
            jQuery(`#${sectionsToSubtract[1]}_section_width_input`).val();
          break;
          case sectionsToSubtract[1] + " and " + sectionsToSubtract[0]:
          newVal =
            width.val() -
            jQuery(`#${sectionsToSubtract[0]}_section_width_input`).val() -
            jQuery(`#${sectionsToSubtract[1]}_section_width_input`).val();
          break;
      }
    }
    if (newVal == undefined) return;
    if (jQuery(`#${sectionToUpdate}_section_width_input`).val() != newVal) {
      jQuery(`#${sectionToUpdate}_section_width_input`).val( Math.round(newVal * 10) / 10);
    }

    // update the inch value
    let target = jQuery(`#${sectionToUpdate}_section_width_input`)[0];
    if (!target) return;
    let group = target.closest('.mm-input-group');
    let value = target.value;
    let output = convertMmToInchesAndFormat(value);
    updateInchValue(group, output);

  }

  function updateHorizontalSectionMinMax() {
    if (cabinet_bay_qty == 2) {
      let left_section_min = Math.round(width.val() * 0.25);
      let right_section_min = Math.round(width.val() * 0.25);
      let left_section_max = Math.round(width.val() * 0.66);
      let right_section_max = Math.round(width.val() * 0.66);

      //remove existing min/max values
      left_section_width_label[0].innerHTML = left_section_width_label[0].innerHTML.replace(
        /\(.*?\)/g,
        ""
      );
      right_section_width_label[0].innerHTML = right_section_width_label[0].innerHTML.replace(
        /\(.*?\)/g,
        ""
      );

      left_section_width_label[0].innerHTML += `(${left_section_min}/${left_section_max})`;
      right_section_width_label[0].innerHTML += `(${right_section_min}/${right_section_max})`;
      left_section_width.attr("min", left_section_min);
      left_section_width.attr("max", left_section_max);
      right_section_width.attr("min", right_section_min);
      right_section_width.attr("max", right_section_max);
    }

    if (cabinet_bay_qty == 3) {
      let left_section_min = Math.round(width.val() * 0.25);
      let middle_section_min = Math.round(width.val() * 0.25);
      let right_section_min = Math.round(width.val() * 0.25);
      let left_section_max = Math.round(width.val() * 0.66);
      let middle_section_max = Math.round(width.val() * 0.66);
      let right_section_max = Math.round(width.val() * 0.66);

      //remove existing min/max values
      left_section_width_label[0].innerHTML = left_section_width_label[0].innerHTML.replace(
        /\(.*?\)/g,
        ""
      );
      middle_section_width_label[0].innerHTML = middle_section_width_label[0].innerHTML.replace(
        /\(.*?\)/g,
        ""
      );
      right_section_width_label[0].innerHTML = right_section_width_label[0].innerHTML.replace(
        /\(.*?\)/g,
        ""
      );

      left_section_width_label[0].innerHTML += `(${left_section_min}/${left_section_max})`;
      middle_section_width_label[0].innerHTML += `(${middle_section_min}/${middle_section_max})`;
      right_section_width_label[0].innerHTML += `(${right_section_min}/${right_section_max})`;
      left_section_width.attr("min", left_section_min);
      left_section_width.attr("max", left_section_max);
      middle_section_width.attr("min", middle_section_min);
      middle_section_width.attr("max", middle_section_max);
      right_section_width.attr("min", right_section_min);
      right_section_width.attr("max", right_section_max);
    }
  }

  updateHorizontalSectionMinMax();
  updateSectionWidth("left", ["right", "middle"]);
  updateSectionWidth("middle", ["left", "right"]);
  updateSectionWidth("right", ["left", "middle"]);
})();
